module["exports"] = [
  "+90-53#-###-##-##",
  "+90-54#-###-##-##",
  "+90-55#-###-##-##",
  "+90-50#-###-##-##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/cell_phone/formats.js
// module id = 2126
// module chunks = 0